import api from './api.js'

// 资源池-解决方案
export function digitalList(params) {
    return api.get('/resource-public/api/v1/digital/item/list', params);
}
// 是否为服务商
export function umitDetailsInfoCurrent(params) {
    return api.get('/resource-intelligence/api/v1/umitDetailsInfo/current', params);
}
// 分类请求
export function securityService(params){
    return api.get('/service-center/api/v1/security/service', params);
}
export function dictionaryTreeList(params){
    return api.get('/service-center/api/v1/dictionary/group/tree/list', params);
}

// 供需对接 首页统计
export function demandInfoDataStatic(){
    return api.get('/resource-intelligence/v1/demandInfo/dataStatic');
}
// 供需对接 获取快捷入口列表
export function demandInfoList(params){
    return api.get('/resource-intelligence/v1/demandInfo/list', params);
}
// 供需对接 列表查询
export function demandInfoQuery(params){
    return api.get('/resource-intelligence/v1/demandInfo/query', params);
}
// 供需对接 根据id获取信息 /v1/demandInfo/{uuid}
export function demandInfoDetail(uuid){
    return api.get(`/resource-intelligence/v1/demandInfo/${uuid}`);
}
// 供需对接 查询是否响应需求
export function demandInfoIsResponse(uuid){
    return api.get(`/resource-intelligence/v1/demandInfo/isResponse/${uuid}`);
}
// 供需对接 响应需求
export function demandInfoDoResponse(uuid){
    return api.get(`/resource-intelligence/v1/demandInfo/doResponse/${uuid}`);
}

// 荣誉榜单 获取快捷入口列表
export function honorQuery(params){
    return api.get('/resource-intelligence/v1/honorRollMain/query', params);
}
// 荣誉榜单 根据id获取信息
export function honorDetail(uuid){
    return api.get(`/resource-intelligence/v1/honorRollMain/${uuid}`);
}

// 单位详情信息 列表
export function unitDetailsInfoList(params){
    return api.get(`/resource-intelligence/v1/unitDetailsInfo/listNew`, params);
}




// WEBPACK FOOTER //
// ./src/utils/honorApi.js